import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const DocumentIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.593 4.644A2.035 2.035 0 0 1 9.073 4h5.221c.554 0 1.079.23 1.463.627l3.066 3.174c.196.202.35.442.453.703.104.261.157.54.157.822v8.521c0 .56-.21 1.102-.593 1.508A2.035 2.035 0 0 1 17.36 20H9.072a2.035 2.035 0 0 1-1.479-.645A2.197 2.197 0 0 1 7 17.848V6.153c0-.56.21-1.102.593-1.509Zm1.48.737a.654.654 0 0 0-.476.212.816.816 0 0 0-.216.56v11.694c0 .217.082.418.216.56.133.14.305.212.475.212h8.29c.17 0 .34-.072.474-.212a.816.816 0 0 0 .216-.56v-8.52a.845.845 0 0 0-.06-.312.778.778 0 0 0-.162-.254l-3.067-3.174a.652.652 0 0 0-.469-.206H9.072Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.454 12.73c0-.38.309-.69.69-.69h4.145a.69.69 0 0 1 0 1.382h-4.145a.69.69 0 0 1-.69-.691ZM10.454 15.655c0-.382.309-.691.69-.691h2.073a.69.69 0 0 1 0 1.381h-2.073a.69.69 0 0 1-.69-.69ZM13.907 7.614V4.691h1.382v2.923c0 .217.082.418.216.56.133.14.304.212.475.212h2.762v1.381H15.98a2.035 2.035 0 0 1-1.48-.644 2.197 2.197 0 0 1-.593-1.509Z"
      fill={color}
    />
  </Svg>
);

export default DocumentIcon;
